@for (spinner of spinnerService.spinners; track spinner) {
  <!-- Spinner types using spinner-border -->
  @if (spinner.type === 'primary') {
    <div class="float-load">
      <div class="text-center">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
  @if (spinner.type === 'secondary') {
    <div class="float-load">
      <div class="text-center">
        <div class="spinner-border text-secondary" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
  @if (spinner.type === 'success') {
    <div class="float-load">
      <div class="text-center">
        <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
  @if (spinner.type === 'danger') {
    <div class="float-load">
      <div class="text-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
  @if (spinner.type === 'warning') {
    <div class="float-load">
      <div class="text-center">
        <div class="spinner-border text-warning" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
  @if (spinner.type === 'info') {
    <div class="float-load">
      <div class="text-center">
        <div class="spinner-border text-info" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
  @if (spinner.type === 'light') {
    <div class="float-load">
      <div class="text-center">
        <div class="spinner-border text-light" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
  @if (spinner.type === 'dark') {
    <div class="float-load">
      <div class="text-center">
        <div class="spinner-border text-dark spinner-pink" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">&nbsp;</span>
        </div>
      </div>
    </div>
  }
  <!-- Spinner-grow version -->
  @if (spinner.type === 'g-dark') {
    <div class="float-load">
      <div class="text-center">
        <div class="spinner-grow text-dark" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
  <!-- Full-screen custom loader -->
  @if (spinner.type === 'loader') {
    <div class="loader-wrapper load-ground">
      <div class="loader"></div>
    </div>
  }
}